import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import auth from '@/core/Auth';
import { Loader } from '@/core/Loader';
import { ErrorBag, handleFormError } from '@/core/common';
import LoginLayout from '@/modules/login/components/LoginLayout.vue';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppInput from '@/core/components/form/AppInput.vue';
import AppButton from '@/core/components/form/AppButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginMfaPage',
  setup(__props) {

const { $gettext } = useGettext();
const router = useRouter();
const code = ref<string>('');
const errors = ref<ErrorBag>({});

const replyChallenge = async () => {
	errors.value = {};

	try {
		await auth.replyMfaChallenge(code.value);
		router.push(auth.getLoginRedirect());
	} catch (e) {
		handleFormError(e as Error, errors);
		Loader.hide();
	}
};

const logout = () => {
	auth.invalidate();
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(LoginLayout, { "page-title": "Verifiera" }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[1] || (_cache[1] = [
        _createTextVNode("Verifiera", -1)
      ]))])), [
        [_directive_translate]
      ]),
      _createElementVNode("form", {
        onSubmit: _withModifiers(replyChallenge, ["prevent"])
      }, [
        _createVNode(AppFormGroup, {
          id: "verify_mfa_code",
          label: _unref($gettext)('Kod'),
          errors: errors.value.code
        }, {
          default: _withCtx(() => [
            _createVNode(AppInput, {
              id: "verify_mfa_code",
              modelValue: code.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((code).value = $event)),
              required: "",
              autocomplete: "one-time-code",
              autofocus: "",
              inputmode: "numeric",
              pattern: "\\d{6}"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label", "errors"]),
        _createElementVNode("p", null, [
          _createVNode(AppButton, {
            class: "t-primary button-block",
            type: "submit"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Fortsätt", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("p", null, [
          _createVNode(AppButton, {
            class: "t-danger button-block",
            type: "button",
            onClick: _withModifiers(logout, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Logga ut", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ], 32)
    ]),
    _: 1
  }))
}
}

})